export const PL_LEVELS = [
  "05",
  "10",
  "15",
  "20",
  "30",
  "40",
  "50",
  "60",
  "70",
  "80",
  "90",
  "100",
  "125",
  "150",
  "175",
  "200",
  "250",
  "300",
  "350",
  "400",
  "450",
  "500",
];



export const columnGroupingModel = PL_LEVELS.map((num) => ({
  groupId: `PL${num}`,
  headerName: `PL${num}`,
  headerAlign: "center",
  align: "center",
  children: [{ field: `PL${num}_Max` }, { field: `PL${num}_Min` }],
}));

export const createInitialTotals = () => {
  const obj = {};
  PL_LEVELS.forEach((num) => {
    const pl = `PL${num}`;
    obj[`${pl}_Max`] = 0;
    obj[`${pl}_Min`] = 0;
  });
  return obj;
};

export const calculateTotals = (rows = []) => {
  const totals = createInitialTotals();

  PL_LEVELS.forEach((num) => {
    const pl = `PL${num.toString().padStart(2, "0")}`;
    const maxField = `${pl}_Max`;
    const minField = `${pl}_Min`;

    totals[maxField] = rows.reduce(
      (sum, row) => sum + (Number(row[maxField]) || 0),
      0
    );

    totals[minField] = rows.reduce(
      (sum, row) => sum + (Number(row[minField]) || 0),
      0
    );
  });

  return totals;
};
